export const FITTING_TYPE_PAGE_STEP_LABEL = 'Fitting type';
export const PIERCING_TYPE_PAGE_STEP_LABEL = 'Piercing type';
export const WELDING_TYPE_PAGE_STEP_LABEL = 'Welding type';
export const ADDRESS_PAGE_STEP_LABEL = 'Your address';
export const MEASURING_ADDRESS_LABEL = 'Property Address';
export const SHOPS_PAGE_STEP_LABEL = 'Find a shop';
export const PROPERTY_ADDRESS_STEP_LABEL = 'Property address';
export const PARTNERS_PAGE_STEP_LABEL = 'Select Stylist';
export const PRODUCTS_PAGE_STEP_LABEL = 'Select Products';
export const GUIDE_PAGE_STEP_LABEL = 'Select Guide';
export const SELECT_TREATMENTS_PAGE_STEP_LABEL = 'Treatments';
export const SELECT_DATE_PAGE_STEP_LABEL = 'Select date';
export const ABOUT_YOU_PAGE_STEP_LABEL = 'About you';
export const REVIEW_PAGE_STEP_LABEL = 'Review';
export const COMPLETE_PAGE_STEP_LABEL = 'Complete';

export const FITTING_TYPE_PAGE_PATTERN = new RegExp('/fitting-type$');
export const PIERCING_TYPE_PAGE_PATTERN = new RegExp('/piercing-type$');
export const WELDING_TYPE_PAGE_PATTERN = new RegExp('/welding-type$');
export const SHOPS_PAGE_PATTERN = new RegExp('/shops$');
export const SELECT_TREATMENT_PAGE_PATTERN = new RegExp('/select-treatment$');
export const PARTNERS_PAGE_PATTERN = new RegExp('/partners$');
export const PRODUCTS_PAGE_PATTERN = new RegExp('/products$');
export const SELECT_DATE_PAGE_PATTERN = new RegExp('/select-date$');
export const ABOUT_YOU_PAGE_PATTERN = new RegExp('/about-you.*$');
export const REVIEW_PAGE_PATTERN = new RegExp('/review$');
export const COMPLETE_PAGE_PATTERN = new RegExp('/bookings/');

export const EDIT_ADDRESS_PAGE_PATTERN = new RegExp('/edit-address$');
export const EDIT_SHOP_PAGE_PATTERN = new RegExp('/edit-shop$');
export const EDIT_PARTNERS_PAGE_PATTERN = new RegExp('/edit-partner$');
export const EDIT_DATE_PAGE_PATTERN = new RegExp('/edit-date$');
